interface FooterProps {
  isDarkMode: boolean;
}

const Footer = ({ isDarkMode }: FooterProps) => (
  <footer
    id="contact"
    className={`relative w-full px-6 md:px-12 pt-24 pb-10 transition-colors duration-700 ${
      isDarkMode ? 'bg-[#080808] text-white' : 'bg-[#ececec] text-black'
    }`}
  >
    <div className="max-w-7xl mx-auto">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8 mb-20">
        <div className="md:col-span-5">
          <div className="text-3xl font-semibold tracking-tight mb-5">Solvarion LTD</div>
          <p
            className={`text-sm md:text-base leading-relaxed max-w-sm mb-8 ${
              isDarkMode ? 'text-white/55' : 'text-black/55'
            }`}
          >
            An IT company building and promoting utility applications — from cleaners and optimisers to AI-powered services. Development, consulting, and digital marketing under one roof.
          </p>
        </div>

        <div className="md:col-span-3">
          <div
            className={`text-[11px] font-mono uppercase tracking-[0.25em] mb-5 ${
              isDarkMode ? 'text-white/40' : 'text-black/40'
            }`}
          >
            Contact
          </div>
          <ul className="space-y-3">
            {[
              { text: "101 King's Cross Road" },
              { text: 'London, WC1X 9LP' },
              { text: 'United Kingdom' },
              { text: '+44 7520 676116', href: 'tel:+447520676116' },
              { text: 'clientservice@solvariontech.com', href: 'mailto:clientservice@solvariontech.com' },
            ].map(({ text, href }) => (
              <li key={text}>
                {href ? (
                  <a
                    href={href}
                    className={`text-sm hover:opacity-70 transition-opacity ${
                      isDarkMode ? 'text-white/80' : 'text-black/75'
                    }`}
                  >
                    {text}
                  </a>
                ) : (
                  <span
                    className={`text-sm ${
                      isDarkMode ? 'text-white/80' : 'text-black/75'
                    }`}
                  >
                    {text}
                  </span>
                )}
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4">
          <div
            className={`text-[11px] font-mono uppercase tracking-[0.25em] mb-5 ${
              isDarkMode ? 'text-white/40' : 'text-black/40'
            }`}
          >
            Legal
          </div>
          <ul className="space-y-3">
            <li>
              <a
                href="/terms"
                className={`text-sm hover:opacity-70 transition-opacity ${
                  isDarkMode ? 'text-white/80' : 'text-black/75'
                }`}
              >
                Terms of Use
              </a>
            </li>
            <li>
              <a
                href="/privacy"
                className={`text-sm hover:opacity-70 transition-opacity ${
                  isDarkMode ? 'text-white/80' : 'text-black/75'
                }`}
              >
                Privacy Policy
              </a>
            </li>
            <li>
              <a
                href="/refund"
                className={`text-sm hover:opacity-70 transition-opacity ${
                  isDarkMode ? 'text-white/80' : 'text-black/75'
                }`}
              >
                Refund Policy
              </a>
            </li>
          </ul>
        </div>
      </div>

      {/* Giant brand mark */}
      <div
        className={`select-none text-[18vw] md:text-[14vw] font-bold tracking-tighter leading-[0.85] mb-14 ${
          isDarkMode ? 'text-white/10' : 'text-black/10'
        }`}
      >
        Solvarion
      </div>

      <div
        className={`flex flex-col md:flex-row items-start md:items-center justify-between gap-4 pt-8 border-t ${
          isDarkMode ? 'border-white/10' : 'border-black/10'
        }`}
      >
        <div
          className={`text-xs font-mono ${
            isDarkMode ? 'text-white/40' : 'text-black/40'
          }`}
        >
          &copy; 2026 Solvarion LTD. Registered in England and Wales. All rights reserved.
        </div>
        <div
          className={`flex items-center gap-2 text-[11px] font-mono uppercase tracking-[0.25em] ${
            isDarkMode ? 'text-white/40' : 'text-black/40'
          }`}
        >
          <span className="w-1.5 h-1.5 rounded-full bg-green-500 animate-pulse" />
          Accepting new projects
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;